import { useLayoutEffect, useState } from 'react'

export default function useDependencyKey(dependency) {
  const [key, setKey] = useState(0)

  useLayoutEffect(() => {
    dependency ? setKey((prev) => prev + 1) : setKey(0)
  }, [dependency])

  return key
}
